<template>
    <v-container fluid>
        <div v-if="!requisitionLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Modify Purcahse Requsition #{{data.code}}</h4>
                    <p class="text-subtitle-1">Purchase Requsition Edit Form</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <PurchaseRequistionForm 
                        ref="requistionForm"
                        v-model="data"
                        
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block  @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn depressed block  @click="handleCancel">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert" />
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex';
import PAlert from './../../components/common/PAlert'
import PurchaseRequistionForm from './../../components/purchase/PurchaseRequisitionForm.vue'
export default {
    name : 'PurchaseRequisitionEditView',
    components: {
        PurchaseRequistionForm,
        PAlert,
    },
    data() {
        return {
            alert: {
                value: false,
                title: "Alert",
                content: "are you sure",
                callback: null
            },
            data: {},
            id: null,
            loading: false,
            requisitionLoading: false,
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "purchase/requisition/findByID",
            pushSupplier: "purchase/supplier/push",
            pushItem: "purchase/item/push",
            pushWarehouse: "purchase/warehouse/push",
            snackbar: "ui/snackbar/show",
            update: "purchase/requisition/update"
        }),
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to save?", callback: this.save}
        },
        handleAddLine() {
            this.$refs.requistionForm.addLine()
        },
        handleCancel() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to discard changes?", callback: this.cancel}
        },
        save() {
            if(!this.$refs.requistionForm.validate()) return;
            this.loading = true;
            this.update(this.data).then(response => {
                this.snackbar({ text: "Purchase Requisition Updated", color: "success"})
                this.$router.push({ name: "PurchaseRequisitionDisplay", params: { id: response.data.id} })
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({ text: message, color: "error" })
            }).finally(() => {
                this.loading = false;
            });
        },
        cancel() {
            this.$router.back()
        },
        fetchRequisition(){
            this.requisitionLoading = true;
            this.findByID(this.id).then(response => {
                this.data = {}
                this.data = this.formatForm(response.data)
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.requisitionLoading = false
            })
        },
        
        formatForm(requisition) {
            this.pushWarehouse(requisition.warehouse)
            return {
                id: requisition.id,
                code: requisition.code,
                date: requisition.date,
                priority: requisition.priority,
                receiving_point: requisition.receiving_point,
                warehouse_id: requisition.warehouse.id,
                lines: requisition.lines.map(line => {
                    this.pushItem(line.item)
                    return {
                        item_id: line.item.id,
                        quantity: line.quantity,
                        measure_unit_id: line.measure_unit.id,
                        description: line.description,
                    }
                }),
                notes: requisition.notes
            }
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.fetchRequisition()
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.fetchRequisition()
        next();
    }
}

</script>

<style>

</style>